module.exports = __webpack_public_path__ + "img/lens-174-plus-00.f0a7bb53.png";